import { css } from 'lit';

export const stylesBase = css`
  :host {
    display: block;
  }
`;

export const stylesDisplay = css`
  :host {
    display: inline-block;
  }
`;
